export default __webpack_public_path__ + "static/media/playbutton.98aa1936.svg";